import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

interface InfoTipProps {
  /** The help text. Keep it to two short sentences. */
  title: React.ReactNode;
  /** Accessible name of the button; say what the tip explains, e.g. "About Type from". */
  label: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

/** Small (i) button that shows a short explanation on hover, focus or tap. */
export const InfoTip: React.FC<InfoTipProps> = ({ title, label, placement = 'top' }) => (
  <Tooltip title={title} placement={placement} arrow enterTouchDelay={0}>
    <IconButton
      size="small"
      aria-label={label}
      sx={{ p: 0.25, color: 'text.secondary', '&:hover': { color: 'text.primary' } }}
    >
      <InfoOutlined sx={{ fontSize: 15 }} />
    </IconButton>
  </Tooltip>
);
